// Incremental parser for text/event-stream bodies (WHATWG SSE framing).
//
// Native EventSource cannot send an Authorization header, so the realtime layer
// reads the stream via fetch and feeds decoded chunks into this parser.
//
// Handles: CRLF / LF / CR line endings (including a CR split across chunks),
// multi-line `data:` accumulation (joined with \n), comment frames (`: keep-alive`),
// `id:` and `event:` fields, and frames split across arbitrary chunk boundaries.
//
// Per the SSE spec, a frame with an empty data buffer is not dispatched
// (comments/heartbeats therefore never reach onFrame — track liveness at the
// chunk level, not the frame level).

export function createSseParser(onFrame) {
  let buffer = ''
  let dataLines = []
  let eventType = ''
  let lastEventId = null

  function processLine(line) {
    if (line === '') {
      // blank line → dispatch accumulated frame
      if (dataLines.length > 0) {
        onFrame({
          id: lastEventId,
          event: eventType || 'message',
          data: dataLines.join('\n'),
        })
      }
      dataLines = []
      eventType = ''
      return
    }
    if (line.startsWith(':')) return // comment frame

    let field
    let value
    const colon = line.indexOf(':')
    if (colon === -1) {
      field = line
      value = ''
    } else {
      field = line.slice(0, colon)
      value = line.slice(colon + 1)
      if (value.startsWith(' ')) value = value.slice(1) // strip a single leading space
    }

    if (field === 'data') {
      dataLines.push(value)
    } else if (field === 'event') {
      eventType = value
    } else if (field === 'id') {
      if (!value.includes('\u0000')) lastEventId = value
    }
    // 'retry' and unknown fields are ignored (reconnect timing is ours)
  }

  return {
    feed(chunk) {
      buffer += chunk
      let start = 0
      for (let i = 0; i < buffer.length; i++) {
        const ch = buffer[i]
        if (ch === '\n') {
          processLine(buffer.slice(start, i))
          start = i + 1
        } else if (ch === '\r') {
          if (i === buffer.length - 1) {
            // CR at the end of the chunk: the matching LF may arrive in the next
            // chunk — hold the CR so we don't emit a phantom empty line.
            break
          }
          processLine(buffer.slice(start, i))
          if (buffer[i + 1] === '\n') i++
          start = i + 1
        }
      }
      buffer = buffer.slice(start)
    },
  }
}
